import { formatApiError, isApiError } from '@/lib/api/error'
import { messages } from '@/lib/i18n/messages'
import { MutationCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

/**
 * Збій сервера чи мережі не має минати мовчки: 4xx форми показують біля полів,
 * а 5xx і обрив зв'язку — тут, одним тостом на всі мутації.
 */
function reportServerFailure(error: unknown) {
  if (isApiError(error) && error.status < 500) return
  const text = isApiError(error) ? formatApiError(error) : messages.errors.unknown
  toast.error(text, { id: 'server-failure' })
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({ onError: reportServerFailure }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) {
          return false
        }
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
